import React, { useMemo } from "react";

import Select, { LabeledValue, SelectProps } from "antd/es/select";
import { defineMessages, useIntl } from "react-intl";

import { GroupByType } from "./enum/GroupByType";

const messages = defineMessages<GroupByType>({
  [GroupByType.GROUP]: {
    id: "home.cards.engagement.filterTypeSelect.byGroup",
    defaultMessage: "By group",
    description: "Engagement Card Filter Type Select by group option",
  },
  [GroupByType.TEAM]: {
    id: "home.cards.engagement.filterTypeSelect.byTeam",
    defaultMessage: "By team",
    description: "Engagement Card Filter Type Select by team option",
  },
  [GroupByType.USER]: {
    id: "home.cards.engagement.filterTypeSelect.byUser",
    defaultMessage: "By user",
    description: "Engagement Card Filter Type Select by user option",
  },
});

type Props = Omit<SelectProps<GroupByType>, "options">;

const FilterTypeSelect: React.FC<Props> = (props) => {
  const intl = useIntl();

  const filterTypeOptions = useMemo<LabeledValue[]>(
    () =>
      (Object.values(GroupByType) as GroupByType[]).map<LabeledValue>((value) => ({
        label: intl.formatMessage(messages[value]),
        value,
      })),
    [intl]
  );

  return <Select<GroupByType> options={filterTypeOptions} {...props} />;
};

export default FilterTypeSelect;
